import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Button from "../../common/button/button";
import LabelWithHR from "../../common/labels/labelWithHR";
import { newModalStyle, submitButtonStyle } from "../../reusable/styles";
import {addViewer, clearViewerData} from "../../actions/viewer";
import { Switch, FormControlLabel, Box } from '@mui/material';
import Style from "../../common/input/inputFieldWithLabel.module.css";

const ModalAddViewerForm = (props) => {
  const { handleSubmit, control } = useForm();
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");

  const dispatch = useDispatch();
  const { viewer } = useSelector((state) => state.viewer);

  const saveViewer = (data) => {
    const newData = {
      username: viewer ? viewer.username : userName,
      firstName: viewer ? viewer.firstName : firstName,
      lastName: viewer ? viewer.lastName : lastName,
      phoneNumber,
      companyName,
      email: props.viewersEmail,
      emailReporting: data.emailReporting,
    };

    console.log('Saving viewer with data:', newData);
    dispatch(addViewer(newData));
    dispatch(clearViewerData());
    props.close();
  };

  const closeModal = () => {
    props.close();
  };

  const { t } = useTranslation();
  return (
    <Modal
      open={props.open}
      closeOnEsc
      onClose={closeModal}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      <div className="modal__headerLine" />
      <div className="modal__title">{t("ModalAddViewer.title")}</div>
      <form className="modalForm" onSubmit={handleSubmit(saveViewer)}>
        <div className="form">
          <LabelWithHR label={t("ModalAddViewerForm.email")} />
          <Controller
            name="email"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type={"text"}
                className="textStyleInput"
                disabled={props.viewersEmail}
                name="email"
                defaultValue={props.viewersEmail}
              />
            )}
          />

          <LabelWithHR label={t("ModalAddViewerForm.username")} />
          <Controller
            name="userName"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                className="textStyleInput"
                disabled={props.viewer}
                name="userName"
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
                defaultValue={props.viewer?.username}
                required
              />
            )}
          />
          <LabelWithHR label={t("ModalAddViewerForm.firstName")} />
          <Controller
            name="firstName"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                className="textStyleInput"
                disabled={props.viewer}
                name="firstName"
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
                defaultValue={props.viewer?.firstName}
                required
              />
            )}
          />
          <LabelWithHR label={t("ModalAddViewerForm.lastName")} />
          <Controller
            name="lastName"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                className="textStyleInput"
                disabled={props.viewer}
                name="lastName"
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
                defaultValue={props.viewer?.lastName}
                required
              />
            )}
          />

          <LabelWithHR label={t("ModalAddViewerForm.phoneNumber")} />
          <Controller
            name="phoneNumber"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                className="textStyleInput"
                name="phoneNumber"
                onChange={(e) => {
                  setPhoneNumber(e.target.value);
                }}
              />
            )}
          />

          <LabelWithHR label={t("ModalAddViewerForm.companyName")} />
          <Controller
            name="companyName"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                className="textStyleInput"
                name="companyName"
                onChange={(e) => {
                  setCompanyName(e.target.value);
                }}
              />
            )}
          />

          <Box sx={{ mb: 2 }}>
            <div className={Style.input__label}>
              {t("ModalAddViewerForm.emailReporting")}
              <hr className={Style.input__hr} />
            </div>
            <Controller
              name="emailReporting"
              control={control}
              defaultValue={false}
              render={({ field: { onChange, value } }) => {
                // Convert string to boolean explicitly
                const booleanValue = value === true || value === "true";

                return (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={booleanValue}
                        onChange={(e) => {
                          console.log('Switch changed to:', e.target.checked);
                          onChange(e.target.checked);
                        }}
                        size="small"
                      />
                    }
                    label={booleanValue ? "Enabled" : "Disabled"}
                    labelPlacement="end"
                  />
                );
              }}
            />
          </Box>

          <Button text={t("Buttons.save")} buttonStyle={submitButtonStyle} />
        </div>
      </form>
    </Modal>
  );
};
export default ModalAddViewerForm;